import React, { useState, useEffect } from 'react';
import { HTTP } from '../api/http-common';
import useUserRoleEffect from '../components/userRoleEffect';
import Loader from '../components/loader';
import ErrorHandlingComponent from '../components/ErrorHandlingComponent';
import { FaEye, FaApple, FaAndroid } from 'react-icons/fa';

export default function Dashboard() {
    const [userObj, setUserObj] = useState(JSON.parse(localStorage.getItem('userObj')));
    const [videos, setVideos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [rerenderFlag, setRerenderFlag] = useState(false);
    
    // Download counts state
    const [downloadCounts, setDownloadCounts] = useState({
        ios_downloads: 0,
        android_downloads: 0
    });
    
    const access_token = localStorage.getItem('access_token');
    const userRole = userObj?.role?.id;
    useUserRoleEffect(userRole);

    useEffect(() => {
        loadPublishedVideos();
        loadDownloadCounts();
    }, []);

    const loadPublishedVideos = async () => {
        try {
            setIsLoading(true);
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'token': access_token
                },
            };

            const response = await HTTP.get('/content/published/videos', config);

            if (response.status === 200) {
                console.log('Videos loaded:', response.data.videos.length); // Debug
                setVideos(response.data.videos);
            }
        } catch (err) {
            console.error('Error loading videos:', err);
            setError(err);
            setRerenderFlag(true);
        } finally {
            setIsLoading(false);
        }
    };

    // Load download counts - NO AUTH REQUIRED
    const loadDownloadCounts = async () => {
        
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'token': access_token
                },
            };
            const response = await HTTP.get('/content/view/download-counts', config);

            if (response.status === 200) {
                console.log('Download counts:', response.data); // Debug
                setDownloadCounts(response.data);
            }
        } catch (err) {
            console.error('Error loading download counts:', err);
            // Don't block the page if this fails
        }
    };

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className="dashboard-page">
            {rerenderFlag && <ErrorHandlingComponent err={error} />}

            {/* WATERMARK */}
            <div className="dashboard-watermark-logo">
                <img src="/images/logo/gsa.svg" alt="GSA Connect Watermark" />
            </div>

            {/* CONTENT */}
            <div className="dashboard-content-wrapper">
                
                {/* Title Section with Download Counts - INLINE */}
                <div className="dashboard-title-section">
                    <h2 className="PageTitle">Published Videos</h2>
                    
                    <div className="stats-inline">

                        
                        {/* SMALL Download Stats */}
                        <div className="download-stats-small">
                            <div className="stat-item">
                                <FaApple className="stat-icon apple" />
                                <span>{downloadCounts.ios_downloads.toLocaleString()}</span>
                            </div>
                            <div className="stat-item">
                                <FaAndroid className="stat-icon android" />
                                <span>{downloadCounts.android_downloads.toLocaleString()}</span>
                            </div>
                        </div>
                                <span className="total-videos-count">{videos.length} Videos</span>
                    </div>
                </div>

                {/* VIDEOS GRID */}
                <div className="published-videos-grid">
                    {videos && videos.length > 0 ? (
                        videos.map((video) => (
                            <div key={video.id} className="published-video-card">
                                {/* POSTER IMAGE */}
                                <div className="poster-image-container">
                                    {video.poster_url ? (
                                        <img
                                            src={video.poster_url}
                                            alt={video.title}
                                            className="poster-image"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    ) : (
                                        <div className="poster-placeholder">
                                            <span>No Image</span>
                                        </div>
                                    )}

                                    {/* VIEW COUNT */}
                                    <div className="views-badge">
                                        <FaEye />
                                        <span>{video.view_count || 0}</span>
                                    </div>
                                </div>

                                {/* TITLE & DESCRIPTION */}
                                <div className="video-details">
                                    <h3 className="video-title-text">{video.title}</h3>
                                    <p className="video-desc-text">
                                        {video.description && video.description.length > 100
                                            ? `${video.description.substring(0, 100)}...`
                                            : video.description}
                                    </p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="empty-state">
                            <p>No published videos available</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}